import { useEffect, useState } from 'react';
import { Box, Container, Tab, Tabs } from '@mui/material';
import { MuscleTagsTab } from './muscle-tags-tab/MuscleTagsTab';
import { BodyZonesTab } from './BodyZonesTab';
import { BoneTagsTab } from './BoneTagsTab';
import { DefaultContainer } from '@/components/DefaultContainer';
import { useSearchParams } from 'react-router-dom';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const CustomTabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

export const BodyZonePartManager = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [searchParams] = useSearchParams();
  const muscleTagId = searchParams.get('muscleTagId');

  useEffect(() => {
    setSelectedTab(0);
  }, [muscleTagId]);

  return (
    <DefaultContainer maxWidth="xl">
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={selectedTab}
          onChange={(_, v) => {
            setSelectedTab(v);
          }}
          aria-label="basic tabs example"
        >
          <Tab label="Muscle Tags" {...a11yProps(0)} />
          <Tab label="Bone Tags" {...a11yProps(1)} />
          <Tab label="Body Zones" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={selectedTab} index={0}>
        <MuscleTagsTab />
      </CustomTabPanel>
      <CustomTabPanel value={selectedTab} index={1}>
        <BoneTagsTab />
      </CustomTabPanel>
      <CustomTabPanel value={selectedTab} index={2}>
        <BodyZonesTab />
      </CustomTabPanel>
    </DefaultContainer>
  );
};
